import { Routes } from "@angular/router";

export const homeDashboardRoutes: Routes = [
  {
    path: "",
    loadChildren: async () => (await import("./domains/home/home.routes")).homeRoutes,
    // canActivate: [AuthGuard],
    // data: { authGuardOptions: COMMON_GUARD_OPTIONS.HOME_DASHBOARD.VIEW },
  },
];
